module.exports = __webpack_public_path__ + "img/tz2.9cf3c21d.jpg";